<template>
  <div class="md-layout text-center">
    <notifications></notifications>
    <div
      class="
        md-layout-item
        md-size-66
        md-medium-size-66
        md-small-size-90
        md-xsmall-size-100
      "
    >
      <!--  header-color="blue" -->
      <live-card> 
        <md-field class="md-form-group" slot="inputs">
          <md-icon>smart_display</md-icon>
          <label>视频类型</label>
          <md-select class="card-select" v-model="video_type">
            <md-option value="1">实时直播</md-option>
            <md-option value="2">回放直播</md-option>
          </md-select>
        </md-field>
        <md-field class="md-form-group" slot="inputs">
          <md-icon><icon-appid/></md-icon>
          <label>APPID<i :style="{color: 'red'}">*</i></label>
          <md-input v-model="appid"></md-input>
        </md-field>
        <md-field class="md-form-group" slot="inputs">
          <md-icon><icon-uid/></md-icon>
          <label>UID<i :style="{color: 'red'}">*</i></label>
          <md-input v-model="uid" type=""></md-input>
        </md-field>
        <md-field class="md-form-group" slot="inputs">
          <md-icon><icon-channel/></md-icon>
          <label>通道号<i :style="{color: 'red'}">*</i></label>
          <md-input v-model="channel" type=""></md-input>
        </md-field>
        <md-field class="md-form-group" slot="inputs">
          <md-icon><icon-account/></md-icon>
          <label>设备账号<i :style="{color: 'red'}">*</i></label>
          <md-input v-model="user" type=""></md-input>
        </md-field>
        <md-field class="md-form-group" slot="inputs">
          <md-icon><icon-cdk/></md-icon>
          <label>设备密码<i :style="{color: 'red'}">*</i></label>
          <md-input v-model="passwd" type=""></md-input>
        </md-field>
        <md-field v-if="video_type == 2" class="md-form-group" slot="inputs">
          <md-icon>schedule</md-icon>
          <!-- <label>时间范围</label> -->
          <!-- 表单-日期范围选择-创建时间 -->
          <div class="md-timepicker">
            <md-field class="md-theme-default">
              <el-date-picker 
                :picker-options="pickerOptions" 
                v-model="create_time" 
                value-format="timestamp" 
                format="yyyy-MM-dd HH:mm:SS" 
                class="md-date-form-item" 
                align="left" 
                type="datetimerange" 
                range-separator="~" 
                prefixIcon="no" 
                :start-placeholder="$I18n('start_time')" 
                :end-placeholder="$I18n('end_time')"/>
            </md-field>
          </div>
        </md-field>
        <md-button slot="footer" class="diy-submit md-info md-round" @click="submit">
          开始直播
        </md-button>
        <md-button slot="footer" class="diy-submit md-round" @click="reset">
          重置
        </md-button>
      </live-card>
    </div>
    <div  v-show="openModal" class="close-btn" @click="close">X</div>
    <modal v-show="openModal" class="lg-modal live-page">
      <!-- 弹窗-主体 -->
      <template slot="body">
        <video ref="videoPlayer" class="video-js"></video>
      </template>
    </modal>
  </div>
</template>
<script>
import { Modal } from '@/components';
import { LiveCard } from "@/components";
import { IconCdk, IconChannel, IconAppid, IconAccount, IconUid } from "@/components/IconSvg";

import videojs from 'video.js';
import 'video.js/dist/video-js.css';

export default {
  components: {
    Modal,
    LiveCard,
    IconCdk,
    IconChannel,
    IconAppid,
    IconAccount,
    IconUid,
  },
  mounted(){
    // this.$errorMsg("???")
  },
  data() {
    return {
      openModal: false,

      video_type: 1,
      uid     : "",
      channel : "",
      user    : "",
      appid   : "",
      passwd  : "",
      create_time: [Date.now(), Date.now()],

      intervalCount: 0, // 定时心跳
      player  : null,   // VideoJS
      pickerOptions: { // 时间范围选择
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  destoryed(){
    this.player.pause();       //暂停
    this.player.currentTime(0);//复位
    clearInterval(this.intervalCount);
  },
  methods: {
    close () {
      this.openModal = false;
      this.player.pause();       //暂停
      this.player.currentTime(0);//复位
      clearInterval(this.intervalCount);
    },
    submit (){
      if(this.uid == "" || this.channel == "" || this.user == "" || this.appid == "" || this.passwd == ""){
        this.$errorMsg(this.$I18n("pls_check_verify"));
        return;
      }
      try{
        // 健全
        this.$api.other_api_liveAuth({
          client_id  : "",
          client_type: 21,
          key        : this.appid,
          type       : 3
        })
          .then(res => {
            if(res.code !== 200){
              if(res.code == 401){
                this.$errorMsg(this.$I18n("error_code_401"));
              } else {
                this.$errorMsg(this.$I18n("error_params"));
              }
              return
            }
            // 获取URL
            this.$api[this.video_type == 1 ?"other_api_liveVideo" :"other_api_backLiveVideo"]({
              acc_token     : res.data.token,
              uid           : this.uid,
              user_id       : this.user,
              user_password : this.passwd,
              ch_no         : this.channel,
              gmt_start : this.create_time[0] * 1000,
              gmt_end   : this.create_time[1] * 1000,
            })
              .then(urlRes => {
                if(urlRes.code !== 200){
                  this.$errorMsg(this.$I18n("error_params"));
                  return
                }
                this.openModal = true;
                // 视频初始化
                this.player = videojs(this.$refs.videoPlayer, {
                  autoplay:true,
                  muted: true,
                  fluid: true,
                  controls: true,
                  techOrder:["html5"],
                  sources:[{
                    type:"application/x-mpegURL",
                    src: urlRes.data.url,
                  }]
                });
                this.player.play();

                let liveBeat = () => {
                  this.$api.other_api_liveBeat({
                    id        : urlRes.data.id,
                    acc_token : res.data.token,
                  },function(){});
                }
                liveBeat();
                this.intervalCount = setInterval(liveBeat , 30 * 1000)
              })
          })
      } catch (e) {
        console.log("ERROR")
        console.error(e)
      }
    },
    reset(){
      this.uid     = "";
      this.channel = "";
      this.appid   = "";
      this.user    = "";
      this.passwd  = "";
    },
  },
};
</script>

<style type="scss" scoped>
  .card-select{
    margin-left: 12px;
  }
  .md-timepicker{
    margin-left: 12px;
    position: relative;
    width: 100%;

    & .md-theme-default{
      position: absolute;
      left: 0;
      right: 0;
      bottom: -10px;
    }
  }
  .close-btn{
    z-index: 10000;
    position: fixed;
    top: 10px;
    right: 10px;
    font-size: 30px;
    font-weight: 600;
    cursor: pointer;
    background: #9999998a;
    width: 50px;
    height: 50px;
    line-height: 50px;
    border-radius: 25px;
  }
  .diy-submit{
    width: 90%;
  }
  .md-form-group{
    margin-top: 30px;
    margin-bottom: 20px;
  }
  .live-page{
    & .modal-container{
      max-width : unset !important;
      background: unset !important;
      box-shadow: unset !important;
    }
  }
</style>
